import moment from "moment";
import { CarrierService } from "./CarrierService";
import { Status } from "./Status";

export interface KpiShipmentStatistic {
  total: number;
  totalCod: number;
  totalNoCod: number;
  statuses: KpiShipmentStatisticDetail[];
  carrierServices: KpiShipmentStatisticDetail[];
  regions: KpiShipmentStatisticDetail[];
}

export interface KpiShipmentStatisticDetail {
  type: string | CarrierService | Status;
  total: number;
}

export interface KpiShipmentStatisticAggregationDaily {
  date: string;
  amount: number;
}

export interface KpiShipmentStatisticFilter {
  start: string;
  end: string;
  statuses?: string[];
  carriers?: string[];
}

export const defaultKpiShipmentStatisticFilter: KpiShipmentStatisticFilter = {
  start: moment().subtract(1, "months").startOf("day").toString(),
  end: moment().endOf("day").toString(),
};
